import * as React from "react";
import * as main from "../../../styles/main.module.scss";
import * as screen3 from "./screen3.module.scss";

export const Results = ({ title }) => {
  return (
    <section className={screen3.screen3} id="results">
      <div className="container">
        <h2 className={`${main.title2} ${screen3.screen3__title}`}>
          { title || `Курс поможет вашему ребёнку:` }
        </h2>
        <div className={screen3.screen3__block}>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-01.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Сократить время выполнения домашних заданий</strong> — ребёнок
              сможет больше отдыхать или уделить внимание увлечениям
            </div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-02.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Быстро обрабатывать информацию,</strong> запоминать новое с
              одного прочтения, пересказывать тексты любого уровня сложности
            </div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-03.png"
              alt=""
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Сохранять информацию в долговременной
              памяти,</strong> качественно готовиться к зачётам, экзаменам и олимпиадам, сохранять знания в течение
              многих лет
            </div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-04.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Запоминать иностранные слова и термины</strong> на высокой
              скорости (по 50 единиц в час и более), что поможет в 2-4 раза быстрее изучать языки, а впоследствии
              быстро осваивать профессии
            </div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-05.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Стать интеллектуально выносливым</strong> — ребёнок сможет
              надолго концентрироваться на учебных задачах
            </div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-06.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Выбирать наиболее эффективные способы</strong> и алгоритмы для
              освоения того или иного вида учебной информации
            </div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-07.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Развить мотивацию на самообучение</strong> и достижение
              намеченных целей
            </div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-08.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Повысить самооценку</strong>, получать удовольствие от
              интеллектуальной деятельности
            </div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-09.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Научиться анализировать и оценивать результаты</strong> своей
              работы
            </div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-10.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Выучить часть материала школьной программы</strong></div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-11.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Самостоятельно повысить успеваемость</strong> по предметам и
              темам, в том числе по тем, которые не затрагиваются в курсе
            </div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-12.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Самостоятельно готовиться к контрольным работам</strong>,
              тестам, экзаменам, олимпиадам
            </div>
          </div>
          <div className={screen3.screen3__blockItem}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/kurs-icon-13.png"
              alt={""}
              className={screen3.blockItem__img}
            />
            <div className={screen3.blockItem__text}><strong>Расширить выбор</strong> форм обучения и учебных заведений.
              Ребёнок сможет сдавать аттестации экстерном, перейти в профильный класс или поступить в гимназию/лицей
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
